import { themeDark, Theme } from '@redislabsdev/redis-ui-styles';

export const themeUi: Theme = themeDark;
